import { render, staticRenderFns } from "./ParterIvitationRequest.vue?vue&type=template&id=75f7020a&scoped=true&"
import script from "./ParterIvitationRequest.vue?vue&type=script&lang=js&"
export * from "./ParterIvitationRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f7020a",
  null
  
)

export default component.exports